import classNames from "classnames"
import styles from "./Input.module.scss"

const Input = ({
  autoFocus,
  className,
  disabled,
  disableAutocomplete,
  maxLength,
  min,
  name,
  onChange,
  onInput,
  onKeyDown,
  onKeyUp,
  placeholder,
  step,
  tabIndex,
  type,
  value,
  max,
}) => {
  return (
    <input
      autoFocus={autoFocus}
      className={classNames(styles.input, className)}
      disabled={disabled}
      autoComplete={disableAutocomplete ? "off" : "on"}
      maxLength={maxLength}
      min={min}
      max={max}
      name={name}
      onChange={(e) => onChange && onChange(e)}
      onInput={(e) => onInput && onInput(e)}
      onKeyDown={(e) => onKeyDown && onKeyDown(e)}
      onKeyUp={(e) => onKeyUp && onKeyUp(e)}
      placeholder={placeholder}
      step={step}
      tabIndex={tabIndex}
      type={type}
      value={value}
    />
  )
}

export default Input
